import React from "react";

import { STATUS_FALHA, STATUS_OK } from "./useStatusDoServidor";

const ROTULOS = {
  [STATUS_OK]: "Operacional",
  [STATUS_FALHA]: "Sem conexão",
};

/** Classe do ponto: verde pulsando (ok), âmbar parado (falha), neutro (verificando). */
export function classeDoPonto(status) {
  if (status === STATUS_OK) return "dot";
  if (status === STATUS_FALHA) return "dot off";
  return "dot wait";
}

export function rotuloDoStatus(status) {
  return ROTULOS[status] || "Verificando";
}

/** Pílula "Operacional" do topo, ligada ao status real do servidor. */
export default function PilulaStatus({ status }) {
  return (
    <span className="pill" role="status" aria-label={`Servidor: ${rotuloDoStatus(status).toLowerCase()}`}>
      <span className={classeDoPonto(status)} aria-hidden="true" />
      {rotuloDoStatus(status)}
    </span>
  );
}
